import config from './config';

class AnalyticsClass {
    constructor() {
        this.queuedEvents = [];

        this.initialized = {
            gtm: false,
        };
        // [this.f] = document.getElementsByTagName('script');
    }

    // ------------------------------
    // Initialization
    // ------------------------------

    initialize({ gaID, customParams = {} }) {
        if (!gaID) return;

        this.gaID = gaID;

        this.initializeGTM(gaID, customParams);
    }

    initializeGTM(gaID, customParams = {}) {
        if (!gaID || this.initialized.gtm) return;

        this.initialized.gtm = true;

        const j1 = document.createElement('script');
        j1.async = true;
        j1.src = `https://www.googletagmanager.com/gtag/js?id=${gaID}`;
        // this.f.parentNode.insertBefore(j1, this.f);
        document.head.appendChild(j1);

        window.dataLayer = window.dataLayer || [];
        window.gtag = function gtag() {
            window.dataLayer.push(arguments);
        };

        const gtagConfig = { send_page_view: false, ...customParams };
        console.info('GA CONFIG:', gtagConfig);
        window.gtag('js', new Date());
        window.gtag('config', gaID, gtagConfig);
    }

    // ------------------------------
    // Tracking
    // ------------------------------

    trackEvent(category, action, label = '', value = null) {
        const options = { event_category: category, event_label: label };

        if (value !== null) {
            options.value = value;
        }

        this.sendEvent('event', action, options);
    }

    trackPage(pageLocation = '', pageTitle = '') {
        const location = pageLocation || window.location.href;
        const title = `${document.title} - ${pageTitle}`;

        this.sendEvent('config', this.gaID, {
            page_title: title,
            page_location: location,
        });
    }

    sendEvent(...data) {
        if (!this.initialized.gtm) return;

        const type = data[0] === 'config' ? 'trackPage' : 'trackEvent';

        // fallback to setTimeout if requestIdleCallback is not supported
        // e.g. safari
        const defer = window.requestIdleCallback || setTimeout;

        defer(() => {
            this.log(`analytics.${type}`, data);
            window.gtag(...data);
        });
    }

    // ------------------------------
    // Debug
    // ------------------------------

    log(title, ...args) {
        if (config.debugAnalytics) {
            console.groupCollapsed(
                `%c ${title} `,
                'background:#4285f4; padding: 1px; border-radius: 3px; color: #fff;',
            );
            console.log(...args);
            console.groupEnd();
        }
    }
}

const Analytics = new AnalyticsClass();

export default Analytics;
